import { Box, CircularProgress } from '@mui/material'
import { Navigate } from 'react-router-dom'

import { usePreference } from '@/hooks/usePreference'

/**
 * Report navigation = 2 màn riêng (ReportsPage = Dashboards, ReportValuePage =
 * Inputs). Section-pointer + last-tab của Inputs nhớ SERVER-SIDE qua generic
 * preferences registry (scope `report`/`navigation` + `report_input`/`navigation`),
 * đồng bộ pattern với dashboard/futures navigation. Tab trong Dashboards vẫn nhớ
 * server-side qua pref `('dashboard','navigation')`.
 */
const Loader = (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 8 }}>
    <CircularProgress size={24} />
  </Box>
)

/** `/report` → SECTION cuối user mở (Dashboards vs Inputs). Fallback Dashboards. */
export default function ReportIndexRedirect() {
  const nav = usePreference<{ lastSection: string }>('report', 'navigation', undefined, { refetchOnMount: true })
  if (nav.isLoading || nav.isFetching) return Loader
  const target = nav.value?.lastSection === 'inputs' ? '/report/inputs' : '/report/dashboards'
  return <Navigate to={target} replace />
}

/** `/report/inputs` → tab Inputs cuối user mở. Fallback `exposure`. */
export function ReportInputsIndexRedirect() {
  const nav = usePreference<{ lastTab: string }>('report_input', 'navigation', undefined, { refetchOnMount: true })
  if (nav.isLoading || nav.isFetching) return Loader
  const VALID = ['exposure', 'cashflows', 'misa-mapping']
  const saved = nav.value?.lastTab
  const tab = saved && VALID.includes(saved) ? saved : 'exposure'
  return <Navigate to={`/report/inputs/${tab}`} replace />
}
